import { BALL, type Ball } from "@golazo/shared";

/** El balon vuela por encima de jugadores de campo. */
export function ballClearsPlayers(ball: Ball): boolean {
  return ball.loft > BALL.LOFT_CLEAR_PLAYERS;
}

/** ¿Puede un jugador capturar el balon a esta altura? */
export function canCaptureLoft(ball: Ball): boolean {
  if (ball.loft <= BALL.LOFT_GROUND_CAPTURE) return true;
  if (ball.loftVel > 20) return false;
  return ball.loft <= BALL.LOFT_CAPTURE_REACH;
}
